global.modules.set({
  async init(context) {
    $(context).on('focusout', '[name="promocode"]', function () {
      var elem = $(this);
      var promocode = elem.val();
      if (!promocode) {
        elem.data('discount', null)
        elem.trigger('change');
        return;
      }
      $.ajax({
        method: 'POST',
        url: '/promocodes/check',
        data: JSON.stringify({ promocode }),
        contentType: 'application/json',
        elem: null,
        success: function (response) {
          if (response.promocode) {
            elem.data('discount', response.promocode.discount)
            elem.trigger('change');
          }
        }
      })
    });

    if ($(context).hasClass('modal__window')) {
      updateOrderPrice($('[name="plan_id"]'));
    }

    $(context).on('change', '[name="plan_id"], [name^="entities[]"], [name="entities[]"], [name="location[]"], [name="promocode"]', function (e) {
      updateOrderPrice($(this));
    })

    $(context).on('delete_last_element', '[name="location[]"]', function (e, params) {
      updateOrderPrice($(this), params);
    });

    function updateOrderPrice(input, params) {
      var form = input.closest('form.modal__content');
      var select = form.find('[name="plan_id"]');
      var price = parseFloat(select.find(`[value="${select.val()}"]`).data('price'));
      var default_price = parseFloat(select.find(`[value="${select.val()}"]`).data('default_price'))
      var entities_length = parseInt(select.find(`[value="${select.val()}"]`).data('entities_length'));
      var discount = parseInt(form.find('[name="promocode"]').data('discount'));
      if (discount) {
        price = price * (100 - discount) / 100;
      }
      const entites = form.find('[name="entities[]"]')[0] ? form.find('[name="entities[]"]').val().length : form.find('.filter-field').length;
      if (params === null) {
        $('.order_total').text(`Total: $${(default_price || 0).toFixed(2)}`);
      } else {
        $('.order_total').text(`Total: $${(price * (entities_length || entites)).toFixed(2)}`);
      }
    }
  }
});
